export const NEPAL_CENTER = { lat: 28.3949, lng: 84.1240 };
